import { Link } from 'react-router-dom';

import { useLocale } from 'context/locale-context';

const DashboardButton = () => {
  const { getLocaleOption } = useLocale();

  return (
    <Link
      to='/questionnaires/patient'
      className='p-button p-component text-center text-2xl home-dashboard-button'
    >
      {getLocaleOption('dashboardButton')}
    </Link>
  );
};

export default DashboardButton;
